<script>
	import AlertCircle from 'lucide/dist/esm/icons/circle-alert.mjs';
	import ArrowRight from 'lucide/dist/esm/icons/arrow-right.mjs';
	import ArrowLeft from 'lucide/dist/esm/icons/arrow-left.mjs';
	import Bell from 'lucide/dist/esm/icons/bell.mjs';
	import CalendarDays from 'lucide/dist/esm/icons/calendar-days.mjs';
	import Check from 'lucide/dist/esm/icons/check.mjs';
	import ChevronDown from 'lucide/dist/esm/icons/chevron-down.mjs';
	import ChevronLeft from 'lucide/dist/esm/icons/chevron-left.mjs';
	import ChevronRight from 'lucide/dist/esm/icons/chevron-right.mjs';
	import ChevronUp from 'lucide/dist/esm/icons/chevron-up.mjs';
	import ChevronsUpDown from 'lucide/dist/esm/icons/chevrons-up-down.mjs';
	import CircleHelp from 'lucide/dist/esm/icons/circle-question-mark.mjs';
	import CircleCheckBig from 'lucide/dist/esm/icons/circle-check-big.mjs';
	import ClipboardList from 'lucide/dist/esm/icons/clipboard-list.mjs';
	import CreditCard from 'lucide/dist/esm/icons/credit-card.mjs';
	import Download from 'lucide/dist/esm/icons/download.mjs';
	import Ellipsis from 'lucide/dist/esm/icons/ellipsis.mjs';
	import Eye from 'lucide/dist/esm/icons/eye.mjs';
	import ExternalLink from 'lucide/dist/esm/icons/external-link.mjs';
	import FileCheck2 from 'lucide/dist/esm/icons/file-check-corner.mjs';
	import FileDown from 'lucide/dist/esm/icons/file-down.mjs';
	import FileText from 'lucide/dist/esm/icons/file-text.mjs';
	import FolderKanban from 'lucide/dist/esm/icons/folder-kanban.mjs';
	import Folder from 'lucide/dist/esm/icons/folder.mjs';
	import FolderOpen from 'lucide/dist/esm/icons/folder-open.mjs';
	import FolderPlus from 'lucide/dist/esm/icons/folder-plus.mjs';
	import Handshake from 'lucide/dist/esm/icons/handshake.mjs';
	import Home from 'lucide/dist/esm/icons/house.mjs';
	import History from 'lucide/dist/esm/icons/history.mjs';
	import Languages from 'lucide/dist/esm/icons/languages.mjs';
	import Landmark from 'lucide/dist/esm/icons/landmark.mjs';
	import ListChecks from 'lucide/dist/esm/icons/list-checks.mjs';
	import LogOut from 'lucide/dist/esm/icons/log-out.mjs';
	import LockKeyhole from 'lucide/dist/esm/icons/lock-keyhole.mjs';
	import Mail from 'lucide/dist/esm/icons/mail.mjs';
	import MapPin from 'lucide/dist/esm/icons/map-pin.mjs';
	import Menu from 'lucide/dist/esm/icons/menu.mjs';
	import MessageCircleQuestion from 'lucide/dist/esm/icons/message-circle-question-mark.mjs';
	import MonitorCog from 'lucide/dist/esm/icons/monitor-cog.mjs';
	import Moon from 'lucide/dist/esm/icons/moon.mjs';
	import PanelLeftClose from 'lucide/dist/esm/icons/panel-left-close.mjs';
	import PanelLeftOpen from 'lucide/dist/esm/icons/panel-left-open.mjs';
	import Paperclip from 'lucide/dist/esm/icons/paperclip.mjs';
	import Phone from 'lucide/dist/esm/icons/phone.mjs';
	import Plus from 'lucide/dist/esm/icons/plus.mjs';
	import Printer from 'lucide/dist/esm/icons/printer.mjs';
	import ReceiptText from 'lucide/dist/esm/icons/receipt-text.mjs';
	import RefreshCw from 'lucide/dist/esm/icons/refresh-cw.mjs';
	import Repeat2 from 'lucide/dist/esm/icons/repeat-2.mjs';
	import Settings from 'lucide/dist/esm/icons/settings.mjs';
	import Search from 'lucide/dist/esm/icons/search.mjs';
	import Sparkles from 'lucide/dist/esm/icons/sparkles.mjs';
	import Sun from 'lucide/dist/esm/icons/sun.mjs';
	import Ticket from 'lucide/dist/esm/icons/ticket.mjs';
	import Timer from 'lucide/dist/esm/icons/timer.mjs';
	import Trash2 from 'lucide/dist/esm/icons/trash-2.mjs';
	import Upload from 'lucide/dist/esm/icons/upload.mjs';
	import UserRound from 'lucide/dist/esm/icons/user-round.mjs';
	import UsersRound from 'lucide/dist/esm/icons/users-round.mjs';
	import Video from 'lucide/dist/esm/icons/video.mjs';
	import X from 'lucide/dist/esm/icons/x.mjs';
	import ZoomIn from 'lucide/dist/esm/icons/zoom-in.mjs';
	import ZoomOut from 'lucide/dist/esm/icons/zoom-out.mjs';

	const icons = {
		'alert-circle': AlertCircle,
		'arrow-right': ArrowRight,
		'arrow-left': ArrowLeft,
		bell: Bell,
		'calendar-days': CalendarDays,
		check: Check,
		'chevron-down': ChevronDown,
		'chevron-left': ChevronLeft,
		'chevron-right': ChevronRight,
		'chevron-up': ChevronUp,
		'chevrons-up-down': ChevronsUpDown,
		'circle-help': CircleHelp,
		'circle-check': CircleCheckBig,
		'clipboard-list': ClipboardList,
		'credit-card': CreditCard,
		download: Download,
		ellipsis: Ellipsis,
		eye: Eye,
		'external-link': ExternalLink,
		'file-check': FileCheck2,
		'file-down': FileDown,
		'file-text': FileText,
		'folder-kanban': FolderKanban,
		folder: Folder,
		'folder-open': FolderOpen,
		'folder-plus': FolderPlus,
		handshake: Handshake,
		history: History,
		home: Home,
		languages: Languages,
		landmark: Landmark,
		'list-checks': ListChecks,
		'log-out': LogOut,
		logout: LogOut,
		lock: LockKeyhole,
		mail: Mail,
		'map-pin': MapPin,
		menu: Menu,
		'message-circle-question': MessageCircleQuestion,
		'monitor-cog': MonitorCog,
		moon: Moon,
		'panel-left-close': PanelLeftClose,
		'panel-left-open': PanelLeftOpen,
		paperclip: Paperclip,
		phone: Phone,
		plus: Plus,
		printer: Printer,
		'receipt-text': ReceiptText,
		refresh: RefreshCw,
		repeat: Repeat2,
		settings: Settings,
		search: Search,
		sparkles: Sparkles,
		sun: Sun,
		ticket: Ticket,
		timer: Timer,
		'trash-2': Trash2,
		upload: Upload,
		'user-round': UserRound,
		'users-round': UsersRound,
		video: Video,
		x: X,
		'zoom-in': ZoomIn,
		'zoom-out': ZoomOut,
	};

	export default {
		name: 'PortalIcon',

		inheritAttrs: false,

		props: {
			name: { type: String, required: true },
			size: { type: [Number, String], default: 20 },
			strokeWidth: { type: [Number, String], default: 1.75 },
			label: { type: String, default: null },
		},

		render(createElement) {
			const icon = icons[this.name];
			if (!icon) {
				return null;
			}

			const children = icon.map(([tag, attrs], index) =>
				createElement(tag, {
					key: `${this.name}-${index}`,
					attrs,
				})
			);

			return createElement(
				'svg',
				{
					class: ['portal-icon', this.$attrs.class],
					attrs: {
						...this.$attrs,
						xmlns: 'http://www.w3.org/2000/svg',
						width: this.size,
						height: this.size,
						viewBox: '0 0 24 24',
						fill: 'none',
						stroke: 'currentColor',
						'stroke-width': this.strokeWidth,
						'stroke-linecap': 'round',
						'stroke-linejoin': 'round',
						'aria-hidden': this.label ? null : 'true',
						'aria-label': this.label,
						role: this.label ? 'img' : null,
					},
					on: this.$listeners,
				},
				children
			);
		},
	};
</script>

<style scoped>
	.portal-icon {
		display: inline-block;
		flex: 0 0 auto;
		vertical-align: middle;
	}
</style>
